// Helper to get stock quantity for Flash WareHouse or Flash Health Pharmacy from related_requests

import Card from "components/Card/Card";
import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  FormControl,
  Grid,
  OverlayTrigger,
  Table,
  Tooltip,
} from "react-bootstrap";
import "../../../assets/css/medicinePrCard.css";
import MedicineWiseBatchersSelect from "./MedicineWiseBatchersSelect";
import {
  getAllPurchaseRequest,
  updatePurchaseRequest,
  geAllPurchaseRequestData,
  deletePurchaseRequest,
  getAllReleaseStockByMediId,
  getPharmacyVerifiedData,
} from "api/purchaseRequest/purchaseRequest";
import {
  getBatchNumberByAllMedicine,
  GetAllSuppliers,
  AddPurchaseOrder,
} from "Listfunction";
import RaisePo from "./RaisePo";
import Swal from "sweetalert2";
import ScreenLoader from "views/Components/screenLoader";
import Collapsible from "react-collapsible";
import NotificationSystem from "react-notification-system";
import PharmacyVerifiedModal from "./PhamcyVerifiedModal";
import PurchaseRequest from "./CreatePurchaseOrder";
import { statusUpdate } from "api/purchaseRequest/purchaseRequest";

const MedicineWiseOrder = (props) => {
  var token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const getStoreId = token.store_id;
  const user_id = token.id;
  const getRole = token.role;
  const _notificationSystem = useRef(null);
  const [scanBatchersModal, setScanBatchersModal] = useState(false);
  const [openPoPop, setOpenPoPop] = useState(false);
  const [selectedMedicineName, setSelectedMedicineName] = useState("");
  const [selectedMedicineId, setSelectedMedicineId] = useState(null);
  const [selectedPurchaseRequestId, setSelectedPurchaseRequestId] =
    useState(null);
  const [isPoSubmitting, setIsPoSubmitting] = useState(false);
  const [selectedRequestedQty, setSelectedRequestedQty] = useState(0);
  const [purchaseRequest, setPurchaseRequest] = useState([]);
  const [loading, setLoading] = useState(false);
  const [getMedicationData, setGetMedicationData] = useState([]);
  const [getRelatedStock, setGetRelatedStock] = useState([]);
  const [getPurchaseRequestData, setGetPurchaseRequestData] = useState([]);
  const [getReleaseStock, setGetReleaseStock] = useState([]);
  const [getPurchaseRequestItems, setGetPurchaseRequestItems] = useState([]);
  const [getSupplierOption, setGetSupplierOption] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [enterPoRaiseQty, setEnterPoRaiseQty] = useState("");
  const [enterPoQty, setEnterPoQty] = useState("");
  const [searchByMedicine, setSearchByMedicine] = useState("");
  const [itemReceivedPharmacy, setItemReceivedPharmacy] = useState(false);
  const [pharmacyVerifiedData, setPharmacyVerifiedData] = useState({});
  const [isPharmacySubmitting, setIsPharmacySubmitting] = useState(false);

  const [openCreatePurchaseOrderModal, setOpenCreatePurchaseOrderModal] =
    useState(false);
  const [selectedCreatePOMedicineId, setSelectedCreatePOMedicineId] =
    useState(null);
  const [selectedCreatePOMedicineName, setSelectedCreatePOMedicineName] =
    useState("");
  const [getPurchaseRequestId, setGetPurchaseRequestId] = useState("");
  const [scannedBatchRows, setScannedBatchRows] = useState([
    {
      batch_no: "",
      medicine_name: "",
      expiry_date: "",
      warehouse_stock: "",
      release_qty: "",
      isScannedBatch: false,
      isNotFifo: false,
    },
  ]);
  const [batchScanSummary, setBatchScanSummary] = useState({
    scannedBatch: "",
    medicineName: "",
    medicineId: null,
    itemCode: "",
    packSize: 0,
    pharmacyStoreId: null,
    // pharmacyStock: "",
  });
  const [editablePackSize, setEditablePackSize] = useState("");
  const batchInputRef = useRef([]);

  const STORE_IDS = {
    WAREHOUSE: Number(getStoreId),
    PHARMACY: Number(getStoreId),
  };

  const getUniqueStoreWiseMedication = (rows = []) =>
    Array.from(
      new Map(
        (rows || []).map((stock, idx) => [
          stock && stock.id !== undefined && stock.id !== null
            ? `id-${stock.id}`
            : `fallback-${idx}`,
          stock,
        ]),
      ).values(),
    );

  const getStoreStockQty = (rows = [], storeId, storeNameHint = "") =>
    (rows || []).reduce((sum, stock) => {
      const stockStoreId = Number(stock && stock.store_id);
      const pharmacyId = Number(
        stock && stock.pharmacies ? stock.pharmacies.id : null,
      );
      const pharmacyName = String(
        (stock && stock.pharmacies && stock.pharmacies.name) || "",
      ).toLowerCase();

      const matchesStore =
        stockStoreId === Number(storeId) ||
        pharmacyId === Number(storeId) ||
        (storeNameHint && pharmacyName.includes(storeNameHint.toLowerCase()));

      return matchesStore
        ? sum +
            Number(
              (stock &&
                (stock.quantity || stock.total_quantity || stock.in_stock)) ||
                0,
            )
        : sum;
    }, 0);

  const getFlashStockQty = (item) => {
    if (!item || !item.related_requests) return 0;
    for (var i = 0; i < item.related_requests.length; i++) {
      var request = item.related_requests[i];
      if (!request.store_wise_medication) continue;
      for (var j = 0; j < request.store_wise_medication.length; j++) {
        var store = request.store_wise_medication[j];
        if (
          store &&
          store.pharmacies &&
          (store.pharmacies.name === "Flash WareHouse" ||
            store.pharmacies.name === "Flash Health Pharmacy")
        ) {
          return store.quantity || 0;
        }
      }
    }
    return 0;
  };

  const resolvePharmacyStoreId = (storeRows = []) =>
    (storeRows || [])
      .map((row) =>
        Number(
          (row && row.store_id) ||
            (row && row.pharmacies && row.pharmacies.id) ||
            0,
        ),
      )
      .find(
        (id) => Number.isFinite(id) && id > 0 && id !== STORE_IDS.WAREHOUSE,
      ) || null;

  const getPurchaseRequestStatusLabel = (status) => {
    const parsedStatus = Number(status);
    if (parsedStatus === 1) return { label: "Submitted", bgColor: "#ffa823" };
    if (parsedStatus === 3) return { label: "Released", bgColor: "#a91079" };
    if (parsedStatus === 4) return { label: "Completed", bgColor: "#008000" };
    if (parsedStatus === 5) return { label: "PO Request", bgColor: "#016875" };
    if (parsedStatus === 2) return { label: "PO Raised", bgColor: "#1450a3 " };
    return { label: "Pending", bgColor: "#D53E0F" };
  };
  const deleteOrder = async (orderId) => {
    const confirmation = await Swal.fire({
      position: "top",
      width: "478px",
      title: "<div style='font-size:26px;font-weight:100;'>Are you sure?</div>",
      html: "<div style='font-size:16px;'>Do you want to delete?</div>",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "<span style='font-size:18px;'>Yes</span>",
      cancelButtonText: "<span style='font-size:18px;'>No</span>",
      allowHtml: true,
    });

    if (confirmation.isConfirmed) {
      const res = await deletePurchaseRequest(orderId, obj);
      console.log(res, "res");

      if (res && res.data && res.data.success) {
        await Swal.fire({
          position: "top",
          width: "478px",
          title: `<div style='font-size:26px;font-weight:100;'>${
            (res && res.data.message) || "Purchase Request deleted successfully"
          }</div>`,
          icon: "success",
          confirmButtonText: "<span style='font-size:18px;'>OK</span>",
          allowHtml: true,
        });

        await getAllPurchaseRequestOrders();
      } else {
        await Swal.fire({
          position: "top",
          width: "478px",
          title: "<div style='font-size:26px;font-weight:100;'>Error</div>",
          html: `<div style='font-size:16px;'>${
            (res && res.data.message) || "Failed to delete purchase request"
          }</div>`,
          icon: "error",
          confirmButtonText: "<span style='font-size:18px;'>OK</span>",
          allowHtml: true,
        });
      }
    }
  };

  useEffect(() => {
    getAllPurchaseRequestOrders();
    const intervalId = setInterval(() => {
      getAllPurchaseRequestOrders();
    }, 240000);
    return () => clearInterval(intervalId);
  }, [searchByMedicine]);

  useEffect(() => {
    if (!scanBatchersModal) return;
    const timer = setTimeout(() => {
      const firstInput =
        batchInputRef.current && batchInputRef.current.length > 0
          ? batchInputRef.current[0]
          : null;
      if (firstInput && typeof firstInput.focus === "function") {
        firstInput.focus();
      }
    }, 150);

    return () => clearTimeout(timer);
  }, [scanBatchersModal, scannedBatchRows.length]);

  const getAllPurchaseRequestOrders = async () => {
    // setLoading(true);
    try {
      const res = await getAllPurchaseRequest(obj, searchByMedicine);
      const data = res.data.data || [];
      setGetPurchaseRequestId(res.data.data.id || null);
      setPurchaseRequest(data);
      console.log(data, "data");
      setGetMedicationData(data.map((item) => item.medication));
      setGetRelatedStock(data.map((item) => item.related_requests));
      setGetPurchaseRequestItems(
        data.flatMap((item) =>
          item.related_requests.flatMap(
            (req) => req.purchase_request_items || [],
          ),
        ),
      );
    } catch (error) {
      console.error("Error fetching warehouse inventory data:", error);
    } finally {
      setLoading(false);
    }
  };
  const getAllPurchaseRequestOrdersByMedId = async (medId) => {
    if (!medId) return;
    try {
      const res = await geAllPurchaseRequestData(obj, medId);
      const purchaseOrders = res.purchase_orders || [];
      console.log(purchaseOrders, "purchaseOrders");
      setGetPurchaseRequestData(purchaseOrders);
    } catch (error) {
      console.error("Error fetching warehouse inventory data:", error);
    } finally {
      setLoading(false);
    }
  };
  const getReleaseStockByMedi = async (medId) => {
    if (!medId) return;
    try {
      const res = await getAllReleaseStockByMediId(obj, medId);
      const releasePayload =
        (res && res.purchase_orders) ||
        (res && res.data && res.data.purchase_orders) ||
        (res && res.data) ||
        [];

      const checkReleaseStock = Array.isArray(releasePayload)
        ? releasePayload
        : releasePayload && typeof releasePayload === "object"
          ? [releasePayload]
          : [];
      setGetReleaseStock(checkReleaseStock);
    } catch (error) {
      console.error("Error fetching warehouse inventory data:", error);
    } finally {
      setLoading(false);
    }
  };
  const getPharmacyVerified = async (prId) => {
    if (!prId) return;
    const res = await getPharmacyVerifiedData(obj, prId);
    const pharmacyVerifiedData = res.data || {};
    setPharmacyVerifiedData(pharmacyVerifiedData);
  };

  // Helper to get pharmacy stock for Flash Health Pharmacy
  const getPharmacyStock = (item) => {
    let qty = 0;
    if (item && item.related_requests && item.related_requests.length > 0) {
      const req = item.related_requests[0];
      if (req.store_wise_medication && req.store_wise_medication.length > 0) {
        for (let i = 0; i < req.store_wise_medication.length; i++) {
          const store = req.store_wise_medication[i];
          if (
            store &&
            store.pharmacies &&
            store.pharmacies.name === "Flash Health Pharmacy"
          ) {
            qty = store.quantity || 0;
            break;
          }
        }
      }
    }
    return qty;
  };

  const openBatchersModal = (medicineOrItem) => {
    // Use requested_qty from the parent item for the modal (matches 'Requested' in UI)
    const requestedQty =
      Number(medicineOrItem && medicineOrItem.requested_qty) || 0;
    setSelectedRequestedQty(requestedQty);

    const medicineId =
      (medicineOrItem &&
        medicineOrItem.medication &&
        medicineOrItem.medication.id) ||
      null;
    const itemCode =
      (medicineOrItem &&
        medicineOrItem.medication &&
        medicineOrItem.medication.item_code) ||
      "";
    const medicineName =
      (medicineOrItem &&
        medicineOrItem.medication &&
        medicineOrItem.medication.title) ||
      "";
    const packSize =
      (medicineOrItem &&
        medicineOrItem.medication &&
        medicineOrItem.medication.pack_size) ||
      (medicineOrItem && medicineOrItem.pack_size) ||
      "";

    const relatedStoreWiseMedication = (
      (medicineOrItem && medicineOrItem.related_requests) ||
      []
    ).flatMap((request) => request.store_wise_medication || []);

    const storeWiseMedication = getUniqueStoreWiseMedication([
      ...((medicineOrItem && medicineOrItem.store_wise_medication) || []),
      ...((medicineOrItem &&
        medicineOrItem.medication &&
        medicineOrItem.medication.store_wise_medication) ||
        []),
      ...relatedStoreWiseMedication,
    ]);

    const pharmacyStoreId = resolvePharmacyStoreId(storeWiseMedication);

    const resolvedPharmacyStock = pharmacyStoreId
      ? getStoreStockQty(storeWiseMedication, pharmacyStoreId, "")
      : 0;
    const warehouseStoreStock = getStoreStockQty(
      storeWiseMedication,
      STORE_IDS.WAREHOUSE,
      "warehouse",
    );

    const medicationBatches =
      (medicineOrItem &&
        medicineOrItem.medication &&
        medicineOrItem.medication.medication_batches) ||
      [];

    const warehouseBatchStock = (medicationBatches || []).reduce(
      (sum, batch) =>
        Number(batch && batch.store_id) === STORE_IDS.WAREHOUSE
          ? sum + (Number(batch && batch.quantity) || 0)
          : sum,
      0,
    );

    const fallbackWarehouseStock = Number(
      (medicineOrItem &&
        (medicineOrItem.warehouse_total_stock ||
          medicineOrItem.total_stock ||
          medicineOrItem.in_stock ||
          medicineOrItem.total_quantity)) ||
        (medicineOrItem &&
          medicineOrItem.medication &&
          (medicineOrItem.medication.warehouse_total_stock ||
            medicineOrItem.medication.total_stock ||
            medicineOrItem.medication.in_stock ||
            medicineOrItem.medication.total_quantity)) ||
        0,
    );

    const resolvedWarehouseStock =
      warehouseStoreStock || warehouseBatchStock || fallbackWarehouseStock || 0;

    const purchaseRequestId =
      (medicineOrItem && medicineOrItem.id) ||
      ((medicineOrItem && medicineOrItem.related_requests) || [])
        .map((request) => request.id)
        .find((requestId) => requestId !== null && requestId !== undefined) ||
      null;

    setSelectedPurchaseRequestId(purchaseRequestId);
    setSelectedMedicineId(medicineId);

    setScannedBatchRows([
      {
        batch_no: "",
        medicine_name: medicineName || "",
        expiry_date: "",
        warehouse_stock: resolvedWarehouseStock,
        release_qty: "",
        isScannedBatch: false,
        isNotFifo: false,
      },
    ]);
    setBatchScanSummary({
      scannedBatch: "",
      medicineName,
      medicineId,
      itemCode,
      packSize,
      pharmacyStoreId,
      warehouseTotalStock: resolvedWarehouseStock,
    });
    setEditablePackSize(packSize ? String(packSize) : "");
    setSelectedPharmacyStock(getPharmacyStock(medicineOrItem));
    setScanBatchersModal(true);
  };
  const openPoModal = (medicineOrItem) => {
    console.log(medicineOrItem, "medicineID");
    const medicineId =
      (medicineOrItem &&
        medicineOrItem.medication &&
        medicineOrItem.medication.id) ||
      ((medicineOrItem && medicineOrItem.related_requests) || [])
        .flatMap((request) => request.purchase_request_items || [])
        .map(
          (requestItem) => requestItem.medication_id || requestItem.id || null,
        )
        .find((id) => id !== null && id !== undefined) ||
      null;
    const medicineName =
      typeof medicineOrItem === "string"
        ? medicineOrItem
        : medicineOrItem && medicineOrItem.medication
          ? `${medicineOrItem.medication.title || ""}${
              medicineOrItem.medication.item_code
                ? ` (${medicineOrItem.medication.item_code})`
                : ""
            }`
          : ((medicineOrItem && medicineOrItem.related_requests) || [])
              .flatMap((request) => request.purchase_request_items || [])
              .map(
                (requestItem) =>
                  requestItem.medicine_name || requestItem.name || "",
              )
              .find((name) => String(name || "").trim()) || "";

    const getPrId = medicineOrItem.id;
    setSelectedMedicineId(medicineId);
    setSelectedMedicineName(String(medicineName || "").trim());
    setSelectedPurchaseRequestId(getPrId || null);
    setEnterPoRaiseQty("");
    setOpenPoPop(true);
  };

  const closeBatchersModal = () => {
    setScanBatchersModal(false);
  };
  const closePurchaseRequestModal = () => {
    setOpenCreatePurchaseOrderModal(false);
  };

  const closePoModal = () => {
    if (isPoSubmitting) return;
    setOpenPoPop(false);
    setEnterPoRaiseQty("");
  };
  const closeItemReceivedPharmacyModal = () => {
    if (isPharmacySubmitting) return;
    setItemReceivedPharmacy(false);
  };
  const changeTheStatus = async (getPurchaseRequestId) => {
    if (!getPurchaseRequestId) {
      console.error("Purchase Request ID missing");
      return;
    }
    const payload = { status: 2 };
    try {
      await statusUpdate(getPurchaseRequestId, payload, obj);
    } catch (error) {
      console.error(error);
    }
  };

  const onCreatePurchaseOrder = async () => {
    if (isPoSubmitting) return;
    let error = false;
    if (!selectedCreatePOMedicineId) {
      await Swal.fire({
        position: "top",
        width: "478px",
        title:
          "<div style='font-size:26px;font-weight:100;'>Medicine is required</div>",
        icon: "warning",
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      return;
    }
    if (!enterPoQty) {
      await Swal.fire({
        position: "top",
        width: "478px",
        title:
          "<div style='font-size:26px;font-weight:100;'>Quantity is required</div>",
        icon: "warning",
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      return;
    }
    if (!selectedSupplier) {
      await Swal.fire({
        position: "top",
        width: "478px",
        html: "<div style='font-size:26px;font-weight:100;'>Supplier is required</div>",
        icon: "warning",
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowOutsideClick: false,
      });
      return;
    }
    // Find selected medicine details if needed
    const selectedMedicine = getMedicationData.find(
      (med) => med && med.id === selectedCreatePOMedicineId,
    );
    const AddPoBody = {
      supplier_id: selectedSupplier && selectedSupplier.value,
      order: [
        {
          account: "200",
          barcode:
            selectedMedicine && selectedMedicine.item_code
              ? selectedMedicine.item_code
              : "",
          deals: "b2c",
          description:
            selectedMedicine && selectedMedicine.title
              ? selectedMedicine.title
              : "",
          discount: "25",
          free_of_goods: 0,
          item_code:
            selectedMedicine && selectedMedicine.item_code
              ? selectedMedicine.item_code
              : "",
          price: "0",
          quantity: Number(enterPoQty),
          tax_rate: "tax",
        },
      ],
      store_id: getStoreId,
    };
    setIsPoSubmitting(true);
    try {
      const res = await AddPurchaseOrder(AddPoBody, obj);
      if (res && res.data && res.data.success) {
        await Swal.fire({
          position: "top",
          width: "478px",
          title:
            "<div style='font-size:26px;font-weight:100;'>Po Created successfully</div>",
          icon: "success",
          confirmButtonText: "<span style='font-size:18px;'>OK</span>",
          allowHtml: true,
        });
        await changeTheStatus(getPurchaseRequestId);
        await getAllPurchaseRequestOrders();
        setOpenCreatePurchaseOrderModal(false);
        setGetSupplierOption([]); // Clear supplier options
        setSelectedSupplier(null); // Also clear selected supplier for robustness
        setEnterPoQty("");
      } else {
        await Swal.fire({
          position: "top",
          width: "478px",
          title: `<div style='font-size:26px;font-weight:100;'>${
            (res && res.data && res.data.message) ||
            "Failed to update release stock"
          }</div>`,
          icon: "error",
          confirmButtonText: "<span style='font-size:18px;'>OK</span>",
          allowHtml: true,
        });
      }
    } catch (error) {
      await Swal.fire({
        position: "top",
        width: "478px",
        title: `<div style='font-size:26px;font-weight:100;'>${
          (error && error.message) || "Something went wrong"
        }</div>`,
        icon: "error",
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
    } finally {
      setIsPoSubmitting(false);
    }
  };
  const handlePharmacyVerifiedSubmit = async (tagPayload) => {
    if (isPharmacySubmitting) return;

    const requestId =
      (tagPayload && tagPayload.id) ||
      (pharmacyVerifiedData && pharmacyVerifiedData.id) ||
      null;

    if (!requestId) {
      await Swal.fire({
        position: "top",
        width: "478px",
        title:
          "<div style='font-size:26px;font-weight:100;'>Purchase request not found</div>",
        icon: "warning",
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      return;
    }

    setIsPharmacySubmitting(true);
    try {
      const res = await updatePurchaseRequest(requestId, obj, tagPayload);

      if (res && res.data && res.data.success) {
        await Swal.fire({
          position: "top",
          width: "478px",
          title:
            "<div style='font-size:26px;font-weight:100;'>Pharmacy verified successfully</div>",
          icon: "success",
          confirmButtonText: "<span style='font-size:18px;'>OK</span>",
          allowHtml: true,
        });

        setItemReceivedPharmacy(false);
        setPharmacyVerifiedData({});
        await getAllPurchaseRequestOrders();
      } else {
        await Swal.fire({
          position: "top",
          width: "478px",
          title: `<div style='font-size:26px;font-weight:100;'>${
            (res && res.data && res.data.message) ||
            "Failed to update pharmacy verification"
          }</div>`,
          icon: "error",
          confirmButtonText: "<span style='font-size:18px;'>OK</span>",
          allowHtml: true,
        });
      }
    } catch (error) {
      await Swal.fire({
        position: "top",
        width: "478px",
        title:
          "<div style='font-size:26px;font-weight:100;'>Something went wrong</div>",
        icon: "error",
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
    } finally {
      setIsPharmacySubmitting(false);
    }
  };
  const handleOnSubmit = async () => {
    if (isPoSubmitting) return;

    if (!selectedPurchaseRequestId) {
      await Swal.fire({
        position: "top",
        width: "478px",
        title:
          "<div style='font-size:26px;font-weight:100;'>Purchase request not found</div>",
        icon: "warning",
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      return;
    }

    const releasedRows = (scannedBatchRows || []).filter(
      (row) => (Number(row && row.release_qty) || 0) > 0,
    );

    if (releasedRows.length === 0) {
      await Swal.fire({
        position: "top",
        width: "478px",
        title:
          "<div style='font-size:26px;font-weight:100;'>Release stock is required</div>",
        html: "<div style='font-size:16px;'>Please enter release qty for at least one batch.</div>",
        icon: "warning",
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      return;
    }

    const totalReleasedQty = releasedRows.reduce(
      (sum, row) => sum + (Number(row.release_qty) || 0),
      0,
    );

    const medicationId = Number(
      batchScanSummary && batchScanSummary.medicineId
        ? batchScanSummary.medicineId
        : selectedMedicineId || 0,
    );

    const normalizedBatches = releasedRows.map((row) => ({
      id: medicationId,
      batch_no: String(row.batch_no || ""),
      expiry_date: row.expiry_date || null,
      quantity: Number(row.release_qty) || 0,
    }));

    if (!medicationId) {
      await Swal.fire({
        position: "top",
        width: "478px",
        title:
          "<div style='font-size:26px;font-weight:100;'>Medicine not found</div>",
        icon: "warning",
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      return;
    }

    const tagPayload = {
      id: String(selectedPurchaseRequestId),
      status: 3,
      medication_id: medicationId,
      medications: {
        medication_id: medicationId,
        quantity: Number(selectedRequestedQty || totalReleasedQty || 0),
        received_quantity: totalReleasedQty,
        batches: normalizedBatches,
      },
      release_qty: totalReleasedQty,
      request_by: user_id,
      store_id: getStoreId,
    };

    setIsPoSubmitting(true);
    try {
      const res = await updatePurchaseRequest(
        selectedPurchaseRequestId,
        obj,
        tagPayload,
      );

      if (res && res.data && res.data.success) {
        await Swal.fire({
          position: "top",
          width: "478px",
          title:
            "<div style='font-size:26px;font-weight:100;'>Stock Released successfully</div>",
          icon: "success",
          confirmButtonText: "<span style='font-size:18px;'>OK</span>",
          allowHtml: true,
        });

        closeBatchersModal();
        setScannedBatchRows([
          {
            batch_no: "",
            medicine_name: "",
            expiry_date: "",
            warehouse_stock: "",
            release_qty: "",
            isScannedBatch: false,
            isNotFifo: false,
          },
        ]);
        setBatchScanSummary({
          scannedBatch: "",
          medicineName: "",
          medicineId: null,
          itemCode: "",
          packSize: 0,
          pharmacyStoreId: null,
          pharmacyStock: "",
        });
        await getAllPurchaseRequestOrders();
      } else {
        await Swal.fire({
          position: "top",
          width: "478px",
          title: `<div style='font-size:26px;font-weight:100;'>${
            (res && res.data && res.data.message) ||
            "Failed to update release stock"
          }</div>`,
          icon: "error",
          confirmButtonText: "<span style='font-size:18px;'>OK</span>",
          allowHtml: true,
        });
      }
    } catch (error) {
      await Swal.fire({
        position: "top",
        width: "478px",
        title: `<div style='font-size:26px;font-weight:100;'>${
          (error && error.message) || "Something went wrong"
        }</div>`,
        icon: "error",
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
    } finally {
      setIsPoSubmitting(false);
    }
  };
  const onSubmit = async () => {
    if (isPoSubmitting) return;
    const quantity = parseInt(enterPoRaiseQty, 10);
    if (!selectedMedicineId) {
      await Swal.fire({
        position: "top",
        width: "478px",
        title:
          "<div style='font-size:26px;font-weight:100;'>Medicine not found</div>",
        icon: "warning",
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      return;
    }

    if (!quantity || Number.isNaN(quantity) || quantity <= 0) {
      await Swal.fire({
        position: "top",
        width: "478px",
        title:
          "<div style='font-size:26px;font-weight:100;'>Quantity is required</div>",
        icon: "warning",
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      return;
    }

    const confirmation = await Swal.fire({
      position: "top",
      width: "520px",
      title:
        "<div style='font-size:26px;font-weight:100;'>Create Purchase Request?</div>",
      html: "<div style='font-size:16px;'>Do you want to submit this PO request?</div>",
      icon: "question",
      showCancelButton: true,
      confirmButtonText:
        "<span style='font-size:18px;padding:0px 10px'>OK</span>",
      cancelButtonText: "<span style='font-size:18px;'>Cancel</span>",
      allowOutsideClick: false,
      showCloseButton: true,
      allowHtml: true,
    });

    if (!confirmation.isConfirmed) return;

    setIsPoSubmitting(true);
    let type = null;

    if (getRole == 11) {
      type = "refillRequest";
    } else if (getRole == 17) {
      type = "PurchaseRequest";
    }

    try {
      const tagPayload = {
        id: String(selectedPurchaseRequestId),
        request_date: new Date().toISOString().split("T")[0],
        status: "5",
        request_by: user_id,
        medications: [
          {
            id: selectedMedicineId,
            po_raised_qty: enterPoRaiseQty,
          },
        ],
        po_raised_qty: enterPoRaiseQty,
        store_id: getStoreId,
        type: type,
      };

      const res = await updatePurchaseRequest(
        selectedPurchaseRequestId,
        obj,
        tagPayload,
      );
      if (res && res.data && res.data.success) {
        await Swal.fire({
          position: "top",
          width: "478px",
          title:
            "<div style='font-size:26px;font-weight:100;'>Purchase Request Created</div>",
          icon: "success",
          confirmButtonText: "<span style='font-size:18px;'>OK</span>",
          allowHtml: true,
        });
        setOpenPoPop(false);
        setEnterPoRaiseQty("");
        await getAllPurchaseRequestOrders();
      } else {
        await Swal.fire({
          position: "top",
          width: "478px",
          title: `<div style='font-size:26px;font-weight:100;'>${
            (res && res.data && res.data.message) ||
            "Failed to create purchase request"
          }</div>`,
          icon: "error",
          confirmButtonText: "<span style='font-size:18px;'>OK</span>",
          allowHtml: true,
        });
      }
    } catch (error) {
      await Swal.fire({
        position: "top",
        width: "478px",
        title: `<div style='font-size:26px;font-weight:100;'>${
          (error && error.message) || "Something went wrong"
        }</div>`,
        icon: "error",
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
    } finally {
      setIsPoSubmitting(false);
    }
  };

  const handleBatchInputChange = (event, index) => {
    const value = event.target.value;
    setBatchScanSummary((prev) => ({
      ...prev,
      scannedBatch: value,
      pharmacyStock: "",
    }));
    // Do NOT reset scannedBatchRows here!
  };

  const handleReleaseQtyChange = (event, index) => {
    const value = event.target.value;
    setScannedBatchRows((prevRows) => {
      const rows = [...prevRows];
      const currentRow = rows[index] || {};
      const maxWarehouseStock = Number(currentRow.warehouse_stock) || 0;

      let releaseQty = "";
      if (value !== "") {
        const parsedValue = Number(value);
        const clampedValue = Math.max(
          0,
          Math.min(
            maxWarehouseStock,
            Number.isNaN(parsedValue) ? 0 : parsedValue,
          ),
        );
        releaseQty = String(clampedValue);
      }

      rows[index] = {
        ...currentRow,
        release_qty: releaseQty,
      };
      return rows;
    });
  };

  const setBatchInputRef = (el, index) => {
    if (!batchInputRef.current) batchInputRef.current = [];
    batchInputRef.current[index] = el;
  };

  const handleBatchNoEnter = async (event, index) => {
    if (event.key === "Enter") {
      event.preventDefault();
      await handleBatchNumber(event.target.value, index);
    }
  };

  const handleBatchNumber = async (batchNo, index) => {
    const value = String(batchNo || "").trim();
    if (!value) return;

    // Check if batch already exists in scannedBatchRows
    const batchIndex = scannedBatchRows.findIndex(
      (row) => row.batch_no === value,
    );
    // Use latest editablePackSize from state
    const packSize = Number(editablePackSize) || 1;

    if (batchIndex !== -1) {
      // Batch exists, increment release_qty only (do not decrement warehouse_stock)
      setScannedBatchRows((prevRows) => {
        const rows = [...prevRows];
        const currentRelease = Number(rows[batchIndex].release_qty) || 0;
        rows[batchIndex] = {
          ...rows[batchIndex],
          release_qty: currentRelease + packSize,
        };
        return rows;
      });
      setBatchScanSummary((prev) => ({ ...prev, scannedBatch: "" }));
      return;
    }
    try {
      const response = await getBatchNumberByAllMedicine(obj, value);
      const payload = response && response.data ? response.data.data : null;
      const medication =
        payload && payload.medication ? payload.medication : payload;

      if (!medication) {
        setScannedBatchRows([
          {
            batch_no: "",
            medicine_name: "",
            expiry_date: "",
            warehouse_stock: "",
            release_qty: "",
            isScannedBatch: false,
            isNotFifo: false,
          },
        ]);
        setBatchScanSummary((prev) => ({
          ...prev,
          scannedBatch: "",
          pharmacyStock: "",
        }));
        await Swal.fire({
          position: "top",
          width: "478px",
          title:
            "<div style='font-size:26px;font-weight:100;'>Batch no not found</div>",
          icon: "warning",
          showCloseButton: true,
          confirmButtonText: "<span style='font-size:18px;'>OK</span>",
          allowHtml: true,
        });
        return;
      }
      const medicationBatches =
        (medication && medication.medication_batches) ||
        (payload && payload.medication_batches) ||
        [];

      const warehouseBatches = medicationBatches.filter(
        (batch) => Number(batch && batch.store_id) === STORE_IDS.WAREHOUSE,
      );

      if (warehouseBatches.length === 0) {
        setScannedBatchRows([
          {
            batch_no: "",
            medicine_name: "",
            expiry_date: "",
            warehouse_stock: "",
            release_qty: "",
            isScannedBatch: false,
            isNotFifo: false,
          },
        ]);
        setBatchScanSummary((prev) => ({
          ...prev,
          scannedBatch: "",
          pharmacyStock: "",
        }));
        await Swal.fire({
          position: "top",
          width: "478px",
          title:
            "<div style='font-size:26px;font-weight:100;'>No warehouse stock found for this batch</div>",
          icon: "warning",
          showCloseButton: true,
          confirmButtonText: "<span style='font-size:18px;'>OK</span>",
          allowHtml: true,
        });
        return;
      }

      const scannedMedicineId = medication && medication.id;
      const expectedMedicineId =
        batchScanSummary && batchScanSummary.medicineId;
      if (
        expectedMedicineId &&
        scannedMedicineId &&
        Number(scannedMedicineId) !== Number(expectedMedicineId)
      ) {
        setBatchScanSummary((prev) => ({
          ...prev,
          scannedBatch: "",
          pharmacyStock: "",
        }));
        setScannedBatchRows([
          {
            batch_no: "",
            medicine_name: "",
            expiry_date: "",
            warehouse_stock: "",
            release_qty: "",
            isScannedBatch: false,
            isNotFifo: false,
          },
        ]);
        await Swal.fire({
          position: "top",
          width: "478px",
          title:
            "<div style='font-size:26px;font-weight:100;'>Medicine not found</div>",
          html: "<div style='font-size:16px;'>The scanned batch does not belong to the selected medicine.</div>",
          icon: "warning",
          showCloseButton: true,
          confirmButtonText: "<span style='font-size:18px;'>OK</span>",
          allowHtml: true,
        });
        return;
      }

      const medicineName = medication.title || "Unknown Medicine";
      const itemCode = medication.item_code || "";
      const packSizeApi =
        medication && medication.pack_size !== undefined
          ? medication.pack_size
          : 0;
      const pharmacyStoreId =
        Number((batchScanSummary && batchScanSummary.pharmacyStoreId) || 0) ||
        resolvePharmacyStoreId(
          (medication && medication.store_wise_medication) || [],
        );

      const pharmacyStockItem = (
        (medication && medication.store_wise_medication) ||
        []
      ).find(
        (stock) =>
          Number(stock && stock.store_id) === Number(pharmacyStoreId) ||
          (stock &&
            stock.pharmacies &&
            Number(stock.pharmacies.id) === Number(pharmacyStoreId)),
      );

      const warehouseStockItem = (
        (medication && medication.store_wise_medication) ||
        []
      ).find(
        (stock) =>
          Number(stock && stock.store_id) === STORE_IDS.WAREHOUSE ||
          (stock &&
            stock.pharmacies &&
            Number(stock.pharmacies.id) === STORE_IDS.WAREHOUSE),
      );

      const medicationWarehouseTotal =
        Number(
          (warehouseStockItem &&
            (warehouseStockItem.quantity ||
              warehouseStockItem.total_quantity)) ||
            (medication &&
              (medication.total_quantity || medication.quantity || 0)) ||
            0,
        ) || 0;

      const sortedBatches = [...warehouseBatches].sort((a, b) => {
        const dateA = new Date(
          a && a.expiry_date ? a.expiry_date : 0,
        ).getTime();
        const dateB = new Date(
          b && b.expiry_date ? b.expiry_date : 0,
        ).getTime();
        return dateA - dateB;
      });

      const fifoBatchNo =
        sortedBatches.length > 0 ? String(sortedBatches[0].batch_no || "") : "";

      const mappedRows = sortedBatches.map((batch) => {
        const currentBatchNo = String(batch.batch_no || "");
        const isScannedBatch =
          currentBatchNo.toLowerCase() === value.toLowerCase();

        return {
          id: batch.id || null,
          order_item_id: batch.order_item_id || 0,
          batch_no: currentBatchNo,
          medicine_name: medication.title || "",
          expiry_date: batch.expiry_date || "",
          warehouse_stock: batch.quantity || 0,
          release_qty: "",
          isScannedBatch,
          isNotFifo:
            isScannedBatch &&
            fifoBatchNo &&
            fifoBatchNo.toLowerCase() !== currentBatchNo.toLowerCase(),
        };
      });

      setBatchScanSummary({
        scannedBatch: value,
        medicineName,
        medicineId: medication.id || null,
        itemCode,
        packSize: packSizeApi,
        pharmacyStoreId: pharmacyStoreId || null,
        warehouseTotalStock: medicationWarehouseTotal,
        pharmacyStock:
          (pharmacyStockItem &&
            (pharmacyStockItem.quantity ||
              pharmacyStockItem.total_quantity ||
              "")) ||
          "",
      });

      setScannedBatchRows(mappedRows);
      setBatchScanSummary((prev) => ({
        ...prev,
        scannedBatch: "",
      }));
    } catch (error) {
      setScannedBatchRows([
        {
          batch_no: "",
          medicine_name: "",
          expiry_date: "",
          warehouse_stock: "",
          release_qty: "",
          isScannedBatch: false,
          isNotFifo: false,
        },
      ]);
      setBatchScanSummary((prev) => ({
        ...prev,
        scannedBatch: "",
        pharmacyStock: "",
      }));
      await Swal.fire({
        position: "top",
        width: "478px",
        title:
          "<div style='font-size:26px;font-weight:100;'>Batch no not found</div>",
        icon: "warning",
        showCloseButton: true,
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
    }
  };

  const getAllSupplierData = async () => {
    const res = await GetAllSuppliers(obj);
    const supplierData = res.data.data || [];
    console.log(supplierData, "supplier data");
    const suppliers = supplierData.map((supplier) => ({
      value: supplier.id,
      label: supplier.name,
    }));
    setGetSupplierOption(suppliers);
  };

  const [selectedPharmacyStock, setSelectedPharmacyStock] = useState(0);

  return (
    <>
      <Grid fluid>
        <NotificationSystem ref={_notificationSystem} />
        <br />
        <Card
          tableFullWidth
          content={
            <div>
              <div className="medicine-search-row">
                <Col md={4} sm={6} xs={12} className="medicine-search-col">
                  <div className="medicine-search-input-wrap">
                    <span className="medicine-search-icon" aria-hidden="true">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11 5a6 6 0 1 1 0 12 6 6 0 0 1 0-12z"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M15.5 15.5L20 20"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                    <FormControl
                      type="text"
                      placeholder="Search By Medicine"
                      className="medicine-search-input"
                      onChange={(e) => setSearchByMedicine(e.target.value)}
                      value={searchByMedicine}
                    />
                  </div>
                </Col>
              </div>
              <div className="medicine-wise-order-container">
                {purchaseRequest && purchaseRequest.length > 0 ? (
                  purchaseRequest.map((item, index) => {
                    const parsedStatus = Number(item && item.status);

                    const totalRequestedQty = (
                      item.related_requests || []
                    ).reduce(
                      (sum, request) =>
                        sum +
                        (request.purchase_request_items || []).reduce(
                          (innerSum, prItem) =>
                            innerSum + Number(prItem.quantity || 0),
                          0,
                        ),
                      0,
                    );

                    const medicineName = item.medication
                      ? `${item.medication.title} (${item.medication.item_code})`
                      : "";

                    const relatedStoreWiseMedication = (
                      item.related_requests || []
                    ).flatMap((request) => request.store_wise_medication || []);
                    var inStock = Number(getFlashStockQty(item)) || 0;
                    var requested = Number(totalRequestedQty) || 0;
                    var Requested_qty = Number(item.requested_qty) || 0;
                    var shortageValue = inStock - requested;
                    var BalanceStock = inStock - Requested_qty;
                    return (
                      <div>
                        <div>
                          <div className=" ">
                            <div className="pr-content-left">
                              <div
                                className="stock-section"
                                style={{
                                  border:
                                    BalanceStock <= 0
                                      ? "2px solid #ea7474"
                                      : "2px solid #90ee90",
                                }}
                              >
                                <div
                                  className="requested-title-row"
                                  style={{ marginBottom: "10px" }}
                                >
                                  <span className="item-number">
                                    {index + 1}
                                  </span>

                                  <div
                                    className="requested-medicine-select"
                                    style={{ width: "69%" }}
                                  >
                                    <p
                                      style={{
                                        fontSize: "20px",
                                        fontWeight: "bold",
                                        margin: 0,
                                      }}
                                    >
                                      {medicineName}
                                    </p>
                                  </div>
                                  <div>
                                    {(() => {
                                      const status =
                                        getPurchaseRequestStatusLabel(
                                          item.status,
                                        );
                                      return (
                                        <button
                                          disabled
                                          style={{
                                            backgroundColor: status.bgColor,
                                            color: "white",
                                            padding: "10px 18px",
                                            border: "none",
                                            borderRadius: "8px",
                                            fontWeight: "900",
                                            cursor: "not-allowed",
                                            letterSpacing: "0.3px",

                                            transition: "all 0.25s ease",
                                            textTransform: "uppercase",
                                            boxShadow:
                                              "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                                          }}
                                        >
                                          {status.label}
                                        </button>
                                      );
                                    })()}
                                  </div>
                                  <div>
                                    <button
                                      onClick={() => deleteOrder(item.id)}
                                      style={{
                                        color: "white",
                                        borderRadius: "5px",
                                        fontSize: "20px",
                                        border: "none",
                                        background: "red",
                                        display: "flex",
                                        padding: "0px 10px",
                                      }}
                                    >
                                      x
                                    </button>
                                  </div>
                                  {/* ) : null}  */}
                                </div>
                                <div className="requested-header-row">
                                  <div className="po-css">
                                    Requested Quantity
                                  </div>
                                  <div className="requested-header-metrics">
                                    <div className="requested-header-metric">
                                      <span>Consumption Level</span>
                                      <strong>
                                        {item.consumption_last_60_days || 0}
                                      </strong>
                                    </div>
                                    <div className="requested-header-metric">
                                      <span>Reorder Level</span>
                                      <strong>{item.reorder_level || 0}</strong>
                                    </div>
                                    <div className="requested-header-metric">
                                      <span style={{ color: "black" }}>
                                        Pharmacy Qty
                                      </span>
                                      <strong>
                                        {(() => {
                                          var qty = 0;
                                          if (
                                            item &&
                                            item.related_requests &&
                                            item.related_requests.length > 0
                                          ) {
                                            var req = item.related_requests[0];
                                            if (
                                              req.store_wise_medication &&
                                              req.store_wise_medication.length >
                                                0
                                            ) {
                                              for (
                                                var i = 0;
                                                i <
                                                req.store_wise_medication
                                                  .length;
                                                i++
                                              ) {
                                                var store =
                                                  req.store_wise_medication[i];
                                                if (
                                                  store &&
                                                  store.pharmacies &&
                                                  store.pharmacies.name ===
                                                    "Flash Health Pharmacy"
                                                ) {
                                                  qty = store.quantity || 0;
                                                  break;
                                                }
                                              }
                                            }
                                          }
                                          return qty;
                                        })()}
                                      </strong>
                                    </div>
                                  </div>
                                </div>
                                <div className="requested-body-layout">
                                  <div className="requested-left-block">
                                    <table
                                      className="stock-table requested-qty-table"
                                      style={{ width: "100%" }}
                                    >
                                      <thead>
                                        <tr>
                                          <th
                                            className="request-section-style-text"
                                            style={{
                                              fontWeight: 600,
                                              textAlign: "left",
                                              padding: "8px 12px",
                                              fontSize: "15px",
                                              background: "#f7f7f7",
                                            }}
                                          >
                                            Order Id
                                          </th>
                                          <th
                                            className="request-section-style-text"
                                            style={{
                                              fontWeight: 600,
                                              textAlign: "right",
                                              padding: "8px 12px",
                                              fontSize: "15px",
                                              background: "#f7f7f7",
                                            }}
                                          >
                                            Qty
                                          </th>
                                          <th
                                            style={{ background: "#f7f7f7" }}
                                          ></th>
                                        </tr>
                                      </thead>
                                      <tbody className="requested-qty-scroll-body">
                                        {item.related_requests &&
                                        item.related_requests.length > 0 ? (
                                          item.related_requests.map(
                                            (request, reqIndex) =>
                                              request.purchase_request_items &&
                                              request.purchase_request_items.map(
                                                (prItem, itemIndex) => (
                                                  <tr
                                                    key={`${reqIndex}-${itemIndex}`}
                                                  >
                                                    <td
                                                      style={{
                                                        fontWeight: 500,
                                                        textAlign: "left",
                                                        padding: "8px 12px",
                                                        verticalAlign: "middle",
                                                      }}
                                                    >
                                                      {request.order_id ||
                                                        "Stock"}
                                                    </td>
                                                    <td
                                                      style={{
                                                        fontWeight: 500,
                                                        textAlign: "right",
                                                        padding: "8px 12px",
                                                        verticalAlign: "middle",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      {prItem.quantity || 0}
                                                      {request.remark ? (
                                                        <OverlayTrigger
                                                          placement="top"
                                                          overlay={
                                                            <Tooltip
                                                              id={`tooltip-remark-${request.id}`}
                                                            >
                                                              {request.remark}
                                                            </Tooltip>
                                                          }
                                                        >
                                                          <i
                                                            className="fa fa-info-circle"
                                                            aria-hidden="true"
                                                            style={{
                                                              fontSize: "16px",
                                                              color: "red",
                                                              marginLeft: "8px",
                                                              cursor: "pointer",
                                                              verticalAlign:
                                                                "middle",
                                                            }}
                                                          ></i>
                                                        </OverlayTrigger>
                                                      ) : null}
                                                    </td>
                                                    <td
                                                      style={{
                                                        textAlign: "center",
                                                        verticalAlign: "middle",
                                                      }}
                                                    >
                                                      {parsedStatus == 1 ? (
                                                        <button
                                                          style={{
                                                            border: "none",
                                                            background:
                                                              "transparent",
                                                            color: "red",
                                                            fontSize: "18px",
                                                            padding: 0,
                                                            marginLeft: "4px",
                                                            cursor: "pointer",
                                                          }}
                                                          type="button"
                                                          onClick={() =>
                                                            deleteOrder(
                                                              prItem.purchase_request_id,
                                                            )
                                                          }
                                                          title="Delete"
                                                        >
                                                          <i className="fa fa-trash-o"></i>
                                                        </button>
                                                      ) : null}
                                                    </td>
                                                  </tr>
                                                ),
                                              ),
                                          )
                                        ) : (
                                          <tr className="noStockAvailable">
                                            <td
                                              colSpan="3"
                                              className="noStockAvailabletext"
                                              style={{
                                                fontWeight: "400",
                                                textAlign: "center",
                                              }}
                                            >
                                              No Requests
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                      <tbody className="requested-qty-total-body">
                                        <tr className="requested-total-row border">
                                          <td
                                            className="requested-total-label"
                                            style={{
                                              fontWeight: "700",
                                              fontSize: "16px",
                                              textAlign: "left",
                                              padding: "8px 12px",
                                            }}
                                          >
                                            Total
                                          </td>
                                          <td
                                            className="requested-total-qty"
                                            style={{
                                              fontWeight: "700",
                                              textAlign: "right",
                                              padding: "8px 12px",
                                            }}
                                          >
                                            {totalRequestedQty}
                                          </td>
                                          <td></td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>

                                  <div className="requested-right-panel">
                                    <div className="requested-main-metrics">
                                      <div className="requested-metric-box">
                                        <span style={{ textAlign: "center" }}>
                                          Store Qty
                                        </span>
                                        <strong style={{ textAlign: "center" }}>
                                          {getFlashStockQty(item)}
                                        </strong>
                                      </div>
                                      <div className="requested-metric-box">
                                        <span>Requested</span>
                                        <strong style={{ textAlign: "center" }}>
                                          {getRole == 13
                                            ? Number(item.po_raised_qty || 0)
                                            : Number(item.requested_qty || 0)}
                                        </strong>
                                      </div>
                                      {getRole !== 13 && (
                                        <div className="requested-metric-box shortage-box">
                                          <span>
                                            {(() => {
                                              const requestedQty = Number(
                                                item.requested_qty || 0,
                                              );
                                              const storeQty = Number(
                                                getFlashStockQty(item),
                                              );
                                              const diff =
                                                storeQty - requestedQty;
                                              return diff < 0
                                                ? "Shortage"
                                                : "Balance";
                                            })()}
                                          </span>
                                          <strong
                                          // style={{
                                          //   color:
                                          //     shortageValue < 0
                                          //       ? "#ea7474"
                                          //       : "#d87449",
                                          // }}
                                          >
                                            {Number(getFlashStockQty(item)) -
                                              Number(item.requested_qty || 0)}
                                          </strong>
                                        </div>
                                      )}
                                    </div>
                                    <div className="requested-actions-row">
                                      {getRole !== 11 ? (
                                        <>
                                          {item.status != 3 &&
                                            item.status != 5 &&
                                            item.status != 2 && (
                                              <button
                                                style={{
                                                  display:
                                                    getRole == 13
                                                      ? "none"
                                                      : "block",
                                                }}
                                                className="pr-primary-action realse-btn"
                                                type="button"
                                                onClick={() =>
                                                  openPoModal(item)
                                                }
                                              >
                                                Purchase Request
                                              </button>
                                            )}
                                          {getFlashStockQty(item) !== 0 && (
                                            <button
                                              style={{
                                                display:
                                                  getRole == 13
                                                    ? "none"
                                                    : "block",
                                              }}
                                              type="button"
                                              className="pr-primary-action realse-btn"
                                              onClick={() =>
                                                openBatchersModal(item)
                                              }
                                            >
                                              Release Stock
                                            </button>
                                          )}
                                        </>
                                      ) : (
                                        <button
                                          type="button"
                                          // disabled={item.status != 3}
                                          className="pr-primary-action realse-btn"
                                          onClick={() => {
                                            setItemReceivedPharmacy(true);
                                            getPharmacyVerified(item.id);
                                          }}
                                        >
                                          {/* {item.status === 3 */}
                                          Item Received
                                          {/* : "Item Pending"} */}
                                        </button>
                                      )}
                                      <button
                                        style={{
                                          display:
                                            getRole == 13 ? "block" : "none",
                                        }}
                                        type="button"
                                        disabled={item.status != 5}
                                        className="pr-primary-action realse-btn"
                                        onClick={() => {
                                          setGetPurchaseRequestId(item.id);
                                          const medicineId =
                                            (item &&
                                              item.medication &&
                                              item.medication.id) ||
                                            (
                                              (item && item.related_requests) ||
                                              []
                                            )
                                              .flatMap(
                                                (request) =>
                                                  request.purchase_request_items ||
                                                  [],
                                              )
                                              .map(
                                                (requestItem) =>
                                                  requestItem.medication_id ||
                                                  requestItem.id ||
                                                  null,
                                              )
                                              .find(
                                                (id) =>
                                                  id !== null &&
                                                  id !== undefined,
                                              ) ||
                                            null;
                                          const medicineName =
                                            typeof item === "string"
                                              ? item
                                              : item && item.medication
                                                ? `${item.medication.title || ""}${
                                                    item.medication.item_code
                                                      ? ` (${item.medication.item_code})`
                                                      : ""
                                                  }`
                                                : (
                                                    (item &&
                                                      item.related_requests) ||
                                                    []
                                                  )
                                                    .flatMap(
                                                      (request) =>
                                                        request.purchase_request_items ||
                                                        [],
                                                    )
                                                    .map(
                                                      (requestItem) =>
                                                        requestItem.medicine_name ||
                                                        requestItem.name ||
                                                        "",
                                                    )
                                                    .find((name) =>
                                                      String(name || "").trim(),
                                                    ) || "";
                                          setSelectedCreatePOMedicineId(
                                            medicineId,
                                          );
                                          setSelectedCreatePOMedicineName(
                                            String(medicineName || "").trim(),
                                          );
                                          setOpenCreatePurchaseOrderModal(true);
                                          getAllSupplierData();
                                        }}
                                      >
                                        Create purchase order
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div className="po-css-text">
                                  <Col className="collapeablecomp_orderhistory">
                                    <Collapsible
                                      trigger="Raised Purchase Order"
                                      transitionTime={200}
                                      onOpening={() =>
                                        getAllPurchaseRequestOrdersByMedId(
                                          item && item.medication
                                            ? item.medication.id
                                            : null,
                                        )
                                      }
                                    >
                                      <Table className="stock-table">
                                        <thead>
                                          <tr>
                                            <th
                                              style={{
                                                textTransform: "capitalize",
                                              }}
                                            >
                                              Po Id
                                            </th>
                                            <th
                                              style={{
                                                textTransform: "capitalize",
                                              }}
                                            >
                                              Request Qty
                                            </th>
                                            <th
                                              style={{
                                                textTransform: "capitalize",
                                              }}
                                            >
                                              Supplier Name
                                            </th>
                                            <th
                                              style={{
                                                textTransform: "capitalize",
                                              }}
                                            >
                                              Created At
                                            </th>
                                            <th
                                              style={{
                                                textTransform: "capitalize",
                                              }}
                                            >
                                              Lead Time
                                            </th>
                                            <th
                                              style={{
                                                textTransform: "capitalize",
                                              }}
                                            >
                                              Arrival Date
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {getPurchaseRequestData &&
                                          getPurchaseRequestData.length > 0 ? (
                                            getPurchaseRequestData.map(
                                              (row, index) => (
                                                <tr key={index}>
                                                  <td
                                                    style={{
                                                      fontWeight: "500",
                                                    }}
                                                  >
                                                    {row.id}
                                                  </td>
                                                  <td
                                                    style={{
                                                      fontWeight: "500",
                                                    }}
                                                  >
                                                    {row.order_items &&
                                                    row.order_items.length > 0
                                                      ? row.order_items[0]
                                                          .quantity
                                                      : 0}
                                                  </td>
                                                  <td
                                                    style={{
                                                      fontWeight: "500",
                                                    }}
                                                  >
                                                    {row.supplier.name}
                                                  </td>
                                                  <td
                                                    style={{
                                                      fontWeight: "500",
                                                    }}
                                                  >
                                                    {row.created_at
                                                      ? row.created_at.split(
                                                          " ",
                                                        )[0]
                                                      : "-"}
                                                  </td>
                                                  <td
                                                    style={{
                                                      fontWeight: "500",
                                                    }}
                                                  >
                                                    {row.supplier
                                                      .lead_time_days || 0}{" "}
                                                    Days
                                                  </td>
                                                  <td
                                                    style={{
                                                      fontWeight: "500",
                                                    }}
                                                  >
                                                    {row.created_at &&
                                                    row.supplier
                                                      ? (() => {
                                                          const date = new Date(
                                                            row.created_at,
                                                          );
                                                          const days =
                                                            row.supplier
                                                              .lead_time_days ||
                                                            0;
                                                          date.setDate(
                                                            date.getDate() +
                                                              days,
                                                          );

                                                          return date
                                                            .toISOString()
                                                            .split("T")[0];
                                                        })()
                                                      : "-"}
                                                  </td>
                                                </tr>
                                              ),
                                            )
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan="12"
                                                style={{ textAlign: "center" }}
                                              >
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                    fontWeight: "400",
                                                    fontSize: "14px",
                                                  }}
                                                >
                                                  No PO raised
                                                </span>
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </Table>
                                    </Collapsible>
                                  </Col>
                                </div>
                                <div className="po-css-text">
                                  <Col className="collapeablecomp_orderhistory">
                                    <Collapsible
                                      trigger="Release History"
                                      transitionTime={200}
                                      onOpening={() =>
                                        getReleaseStockByMedi(
                                          item && item.medication
                                            ? item.medication.id
                                            : null,
                                        )
                                      }
                                    >
                                      <Table className="stock-table">
                                        <thead>
                                          <tr
                                            style={{
                                              textTransform: "capitalize",
                                            }}
                                          >
                                            <th
                                              style={{
                                                textTransform: "capitalize",
                                              }}
                                            >
                                              Id
                                            </th>
                                            <th
                                              style={{
                                                textTransform: "capitalize",
                                              }}
                                            >
                                              Quantity
                                            </th>
                                            <th
                                              style={{
                                                textTransform: "capitalize",
                                              }}
                                            >
                                              Requested By
                                            </th>
                                            <th
                                              style={{
                                                textTransform: "capitalize",
                                              }}
                                            >
                                              Refill Requested Date
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {getReleaseStock &&
                                          getReleaseStock.length > 0 ? (
                                            getReleaseStock.map(
                                              (row, index) => (
                                                <tr key={index}>
                                                  <td
                                                    style={{
                                                      fontWeight: "500",
                                                    }}
                                                  >
                                                    {row.purchase_request_id}
                                                  </td>
                                                  <td
                                                    style={{
                                                      fontWeight: "500",
                                                    }}
                                                  >
                                                    {row.quantity}
                                                  </td>
                                                  <td
                                                    style={{
                                                      fontWeight: "500",
                                                    }}
                                                  >
                                                    {(row.request_by_name &&
                                                      row.request_by_name
                                                        .name) ||
                                                      row.request_by ||
                                                      row.refilled_by ||
                                                      "-"}
                                                  </td>
                                                  <td
                                                    style={{
                                                      fontWeight: "500",
                                                    }}
                                                  >
                                                    {row.created_at
                                                      ? row.created_at.split(
                                                          " ",
                                                        )[0]
                                                      : "-"}
                                                  </td>
                                                </tr>
                                              ),
                                            )
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan="5"
                                                style={{ textAlign: "center" }}
                                              >
                                                <span
                                                  style={{
                                                    textAlign: "center",
                                                    fontWeight: "400",
                                                  }}
                                                >
                                                  No Released Data
                                                </span>
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </Table>
                                    </Collapsible>
                                  </Col>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* )} */}
                      </div>
                    );
                  })
                ) : (
                  <div
                    style={{
                      gridColumn: "1 / -1",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "#fff",
                      color: "#5f6873",
                      fontSize: "18px",
                      fontWeight: "500",
                    }}
                  >
                    No data found
                  </div>
                )}
              </div>
            </div>
          }
        />
        <div>
          <MedicineWiseBatchersSelect
            show={scanBatchersModal}
            onHide={closeBatchersModal}
            handleBatchNoEnter={handleBatchNoEnter}
            handleBatchInputChange={handleBatchInputChange}
            handleReleaseQtyChange={handleReleaseQtyChange}
            setBatchInputRef={setBatchInputRef}
            scannedBatchRows={scannedBatchRows}
            batchScanSummary={batchScanSummary}
            totalRequestedQty={selectedRequestedQty}
            handleOnSubmit={handleOnSubmit}
            getRole={getRole}
            editablePackSize={editablePackSize}
            setEditablePackSize={setEditablePackSize}
            pharmacyStock={selectedPharmacyStock}
          />
        </div>
        <div>
          <RaisePo
            show={openPoPop}
            onHide={closePoModal}
            getSupplierOption={getSupplierOption}
            medicineName={selectedMedicineName}
            onSubmit={onSubmit}
            setEnterPoRaiseQty={setEnterPoRaiseQty}
            enterPoRaiseQty={enterPoRaiseQty}
            isSubmitting={isPoSubmitting}
          />
        </div>
        <div>
          <PharmacyVerifiedModal
            show={itemReceivedPharmacy}
            onHide={closeItemReceivedPharmacyModal}
            pharmacyVerifiedData={pharmacyVerifiedData}
            onSubmitPharmacyVerified={handlePharmacyVerifiedSubmit}
            isSubmitting={isPharmacySubmitting}
            getStoreId={getStoreId}
          />
        </div>
        <div>
          <PurchaseRequest
            show={openCreatePurchaseOrderModal}
            onHide={closePurchaseRequestModal}
            closePurchaseRequestModal={closePurchaseRequestModal}
            onCreatePurchaseOrder={onCreatePurchaseOrder}
            isSubmitting={isPharmacySubmitting}
            getSupplierOption={getSupplierOption}
            selectedSupplier={selectedSupplier}
            setSelectedSupplier={setSelectedSupplier}
            medicineName={selectedCreatePOMedicineName}
            enterPoQty={enterPoQty}
            setEnterPoQty={setEnterPoQty}
          />
        </div>
      </Grid>
    </>
  );
};
export default MedicineWiseOrder;
